import {Component, OnDestroy, OnInit} from '@angular/core';
import * as _ from "lodash";
import {BaseComponent} from "../../base.component";
import {UserService} from "../../common/user.service";
import {LoggerService} from "../../common/logger.service";
import {AddUpsellService} from "../../common/add-upsell.service";
import {Subscription} from 'rxjs';
import {AnalyticsService} from "../../analytics/analytics.service";
import {NavigationEnd, Router} from "@angular/router";
import {Constants} from "../../constants";
import {uxCartPath} from "../../util/locale-util";
import {filter} from "rxjs/operators";
import {TranslateService} from "../../translation/translate.service";
import {LocaleUtil} from "../../util/locale-util";
import {Util} from "../../util/util";

export const PREHEADER_BLACK_LIST: string[] = [
    uxCartPath(Constants.AUTO_ORDER_STATE, Constants.AUTO_ORDER_MANAGE_STATE),
    uxCartPath(Constants.ENROLL_STATE, Constants.ENROLL_AFFILIATE_STATE),
    uxCartPath(Constants.ENROLL_STATE, Constants.ENROLL_ASSOCIATE_STATE),
    uxCartPath(Constants.ENROLL_STATE, Constants.ENROLL_PC_STATE),
    uxCartPath(Constants.ENROLL_STATE, Constants.ENROLL_TEMP_STATE),
    uxCartPath(Constants.MARKETING_PAGE_STATE, Constants.SHARE_NAME_AFFILIATE_SIGNUP),
    uxCartPath(Constants.MARKETING_PAGE_STATE, Constants.SHARE_NAME_ASSOCIATE_SIGNUP),
    uxCartPath(Constants.MARKETING_PAGE_STATE, Constants.SHARE_NAME_PC_SIGNUP),
    uxCartPath(Constants.OLD_ENROLL_PC_ROUTE),
    uxCartPath(Constants.OLD_ENROLL_PC_INFO_ROUTE),
    uxCartPath(Constants.OLD_ENROLL_PC_INFO_ROUTE_2),
    uxCartPath(Constants.OLD_ENROLL_AFFILIATE_ROUTE),
];

@Component({
    selector: 'preheader',
    templateUrl: './preheader.component.html',
    styleUrls: ['./preheader.component.scss'],
    standalone: false
})
export class PreheaderComponent extends BaseComponent implements OnInit, OnDestroy {

    showPreheader: boolean = false;
    showPcUpsell: boolean = false;
    showAoUpsell: boolean = false;
    upsellSubscriptions: Subscription;
    hidePreheader: boolean = false;
    path: string;
    position: string = 'PREHEADER';
    pcUpsellTranslation: string;

    constructor(
        private userService: UserService,
        private loggerService: LoggerService,
        private analyticsService: AnalyticsService,
        private addUpsellService: AddUpsellService,
        private router: Router,
        private translateService: TranslateService
    ) {
        super(userService, loggerService);
    }

    ngOnInit() {
        this.upsellSubscriptions = this.addUpsellService.addUpsellSubject.subscribe((value) => {
            if (!_.isEmpty(value)) {
                this.showPcUpsell = value.pcUpsell;
                this.showAoUpsell = value.aoUpsell;
                this.showPreheader = (value.pcUpsell || value.aoUpsell);

                this.router.events.pipe(
                    filter((event) => event instanceof NavigationEnd)
                ).subscribe((event: NavigationEnd) => {
                    this.preheaderPromoView(LocaleUtil.removeLocaleFromUrl(event.url));
                });
                this.preheaderPromoView(LocaleUtil.removeLocaleFromUrl(this.router.url));
            }
        });

        this.getCustomerData().then(() => {
            const pcUpsellTag = this.showCart ? 'cart.preheader.pc.upsell.title' : 'cart.preheader.pc.upsell.title.retail';
            this.translateService.translate(pcUpsellTag).then((translation: string) => {
                this.pcUpsellTranslation = translation;
            });
        });
    }

    ngOnDestroy() {
        this.upsellSubscriptions.unsubscribe();
    }

    preheaderPromoView(url: string) {
        url = Util.removeUrlParams(url);
        if(!_.find(PREHEADER_BLACK_LIST, (blackListUrl: string) => url === blackListUrl) && this.showPreheader) {
          this.hidePreheader = false;
          this.analyticsService.upsellPromotionViewEvent( this.showPcUpsell, url, this.position);
        } else {
          this.hidePreheader = true;
        }
    }

    closePreheader(){
        this.showPreheader = false;
    }

    sendUpsellPromotionClick() {
        this.analyticsService.upsellPromotionClickEvent( this.showPcUpsell, this.path, this.position);
    }

}
